export default __webpack_public_path__ + "locales/hy-AM/Common.json?hash=15177cfa266f82dd222694c037c92946";